import { Circle, CircleInner } from './CircleComponent'
import { Stat, StatIcon, StatMetric, StatsContainer } from './StatsComponents'
import RightArrowIcon from '../../../icons/RightArrowIcon'
import Source from './SourceComponent'
import React, { useMemo } from 'react'
import styled from '@emotion/styled'
import Big from 'big.js'
import BuildingIcon from '../../../icons/BuildingIcon'
import { useQuery, useSuspenseQuery } from '@apollo/client'
import { getTimeframe } from '../../../utils/getTimeframe'
import { FETCH_DELTA_FOR_PERIOD_QUERY } from '../../../energy/queries/metrics'
import { Name } from './NameComponent'
import { useRecoilValue } from 'recoil'
import { timeframe } from '../../../store'

const BuildingCircleInner = styled(CircleInner)`
  border-color: #008cff;
  gap: 8px;
`

interface PowerOverviewBuildingComponentProps {
  building: any
}

const PowerOverviewBuildingComponent = ({ building }: PowerOverviewBuildingComponentProps) => {
  const selectedTimeframe = useRecoilValue(timeframe)

  const devices = useMemo(() => {
    // @ts-ignore
    return building?.map(device => device.deviceId) ?? []
  }, [building])

  const { start, end, window, tickValues } = useMemo(() => {
    return getTimeframe(selectedTimeframe)
  }, [selectedTimeframe])

  const { data: importData } = useSuspenseQuery(FETCH_DELTA_FOR_PERIOD_QUERY, {
    variables: {
      input: {
        devices: devices,
        end,
        start,
        measurement: 'energyImported'
      }
    },
    skip: !Boolean(building?.length > 0)
  })

  const totalImport: Big = useMemo(() => {
    // @ts-ignore
    return (
      importData?.getDeltaForPeriod?.reduce((acc, cv) => {
        return acc.plus(Big(cv.delta))
      }, Big(0)) ?? Big(0)
    )
  }, [importData?.getDeltaForPeriod])

  return (
    <Source>
      <Circle>
        <BuildingCircleInner>
          <Name>Verbruik</Name>
          <BuildingIcon fill="#9196BB" />
          <StatsContainer>
            <Stat>
              <StatIcon>
                <RightArrowIcon />
              </StatIcon>
              <StatMetric>{totalImport.round(1).toNumber()} kWh</StatMetric>
            </Stat>
          </StatsContainer>
        </BuildingCircleInner>
      </Circle>
    </Source>
  )
}

export default PowerOverviewBuildingComponent
